import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Services from "@/pages/services/page";
import PoolMaintenance from "@/pages/services/pool-maintenance/page";
import PoolOpeningsClosings from "@/pages/services/pool-openings-closings/page";
import IngroundPools from "@/pages/services/inground-pools/page";
import AboveGroundPools from "@/pages/services/above-ground-pools/page";
import PoolStairs from "@/pages/services/pool-stairs/page";
import SpaCovers from "@/pages/services/spa-covers/page";
import AutomaticPoolCleaners from "@/pages/services/automatic-pool-cleaners/page";
import PoolHeaters from "@/pages/services/pool-heaters/page";
import PoolSaltChlorineGenerators from "@/pages/services/pool-salt-chlorine-generators/page";
import Contact from "@/pages/contact/page";
import PoolQuote from "@/pages/pool-quote/page";

import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About /> },
      { path: "/services", element: <Services /> },
      { path: "/services/pool-maintenance", element: <PoolMaintenance /> },
      { path: "/services/pool-openings-closings", element: <PoolOpeningsClosings /> },
      { path: "/services/inground-pools", element: <IngroundPools /> },
      { path: "/services/above-ground-pools", element: <AboveGroundPools /> },
      { path: "/services/pool-stairs", element: <PoolStairs /> },
      { path: "/services/spa-covers", element: <SpaCovers /> },
      { path: "/services/automatic-pool-cleaners", element: <AutomaticPoolCleaners /> },
      { path: "/services/pool-heaters", element: <PoolHeaters /> },
      { path: "/services/pool-salt-chlorine-generators", element: <PoolSaltChlorineGenerators /> },
      { path: "/contact", element: <Contact /> },
      { path: "/pool-quote", element: <PoolQuote /> },
      
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;